<p-dialog 
  [(visible)]="visible" 
  [modal]="true" 
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '80vw', maxWidth: '800px'}"
  [baseZIndex]="10000"
  (onHide)="onHide()">
  
  <ng-template pTemplate="header">
    <h4 class="m-0">{{title}}</h4>
  </ng-template>
  
  <div *ngIf="termsContent" class="terms-content">
    <div style="
              width: 33rem;
              height: 305px;
              overflow-y: auto;
              font-size: 14px;
              margin-bottom: 1rem;
              margin-left: 0rem;
              min-width: 100%;
              border: 1px solid #cdd8d8;
              border-radius: 4px;" 
              [ngxSummernoteView]="termsContent.text">
    </div>
  </div>
  
  <div *ngIf="!termsContent" class="p-4 text-center">
    <p>Loading terms and conditions...</p>
  </div>
  
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Close" class="p-button-secondary" (click)="onHide()"></button>
  </ng-template>
</p-dialog>